import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_BACK_NODE}/empresa`

export function actualizarEmpresa(body) {
  return http.post(`${API_ENDPOINT}/actualizarEmpresa`, body)
}
